import React from "react"
import { Spinner } from "reactstrap"
import './index.css'

export default function PageLoading() {
  return (
    <div className="page-loading">
      <Spinner />
    </div>
  )
}